import { cva } from 'class-variance-authority';

const badgeVariants = cva(
  'inline-flex items-center rounded-[10px] px-2.5 py-1 text-xs leading-5 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        neutral: 'bg-seapoint-gray/10 text-black',
        positive: 'bg-seapoint-green-badge/20 text-seapoint-green-badge',
        attention: 'bg-seapoint-gray/10 text-seapoint-orange',
        negative: 'bg-seapoint-red/10 text-seapoint-red-dark',
        warning: 'bg-seapoint-yellow/20 text-seapoint-gray-very-dark',
        info: 'bg-seapoint-blue/10 text-seapoint-blue-dark',
        discover: 'bg-seapoint-purple/10 text-seapoint-purple-dark',
      },
      shape: {
        rectangle: 'rounded-[10px]',
        pill: 'rounded-3xl',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  },
);

export { badgeVariants };
